
import { Component, Prop, Vue } from 'vue-property-decorator'

import { MultiChoiceCard, DotationOperation } from '@/models'
import { extractApiErrorMessages } from '@/utils/apiErrors'
import {
  getRevokeDescriptionKey,
  getRevokeEmailWarningKey,
  getRevokeScenario
} from '@/utils/revokeDialog'

@Component({
  name: 'RevokeMultiChoiceCardDialog'
})
export default class extends Vue {
  @Prop({ required: true }) private visible!: boolean
  @Prop({ required: true }) private card!: MultiChoiceCard
  @Prop({ required: true }) private operation!: DotationOperation

  private loading = false

  get emailWarningKey(): string {
    const scenario = getRevokeScenario(this.card, this.operation.preIssue)
    return getRevokeEmailWarningKey(scenario)
  }

  get descriptionKey(): string {
    return getRevokeDescriptionKey(getRevokeScenario(this.card, this.operation.preIssue))
  }

  private notifyErrors(err: any): void {
    const messages = extractApiErrorMessages(err)
    const fallback = String(this.$t('gifts.revokeDialog.notification.error.fallback'))
    const toDisplay = messages.length > 0 ? messages : [fallback]

    for (const message of toDisplay) {
      this.$notify({
        title: String(this.$t('gifts.revokeDialog.notification.error.title')),
        message,
        type: 'error',
        duration: 5000
      })
    }
  }

  async submit() {
    this.loading = true
    try {
      await this.operation.revoke(this.card.id)
      this.$notify({
        title: String(this.$t('gifts.revokeDialog.notification.success.title')),
        message: String(this.$t('gifts.revokeDialog.notification.success.message')),
        type: 'success',
        duration: 2000
      })
      this.$emit('revoked')
      this.$emit('close')
    } catch (err: any) {
      this.notifyErrors(err)
    } finally {
      this.loading = false
    }
  }
}
